
import GoingForm from "../../jsCom/comCtl/goingForm";
import {GoingUtils,AssertUtils} from "goingutils";
import _initMoreQueryEvent from "../../common/initMoreQueryEvent";
import _initQueryPanelByDxCell from "../../common/initQueryPanelByDxCell";
import EditorTypeUtils from "../../common/editorTypeUtils";




function _addBtnToParent() {
    $(`<div class="btn-item pull-left" style="margin-left: 6px;" id="${
        this.btnId
        }">
            <div class="btn-item btnItem">
                <div class="goBtn btn-circle">
                    <div class="btnImg"><i class="ivu-icon ivu-icon-ios-search"></i></div>
                    <div class="btnLabel">高级</div>
                </div>
             </div>
        </div>`).appendTo($("#" + this.parentId));
}


function _closeMoreQueryById(targetObj, moreQueryPanelId) {
    $("#" + moreQueryPanelId)
        .removeClass("fadeInRight")
        .addClass("fadeOutRight");
    setTimeout(function () {
        $("#" + moreQueryPanelId).hide();
        $(".more-query-cover").remove();
    }, 300);
    $(targetObj).hide();
}
window._closeMoreQueryById=_closeMoreQueryById;

export default class MoreQueryCtl {

    constructor(parentId, fieldAry, vueObj, searchFun) {
        this.searchFun = searchFun;
        this.parentId = parentId;
        this.dxLayout = false;
        this.goCard = false;
        this.initBody = false;
        this.fieldAry = fieldAry;
        this.labelWidth = 110;
        this.inputWidth = 230;
        this.vueObj = vueObj;
        this.colNum = 1;
        this.prefixCls = GoingUtils.getUUid(12).substring(0, 11);
        if (AssertUtils.isNotNull(parentId)) {
            this.initContainer();
            this.initEvent();
        }
    }

    //初始化容器
    initContainer() {
        this.btnId = GoingUtils.getUUid(12);
        this.moreQueryPanelId = GoingUtils.getUUid(12);
        _addBtnToParent.call(this);
        //如果是通过dx的layout激活的表格
        if (
            AssertUtils.isNotNull(
                $("#" + this.parentId)
                    .closest(".dhx_cell_layout")
                    .get(0)
            )
        ) {
            this.dxLayout = true;
            _initQueryPanelByDxCell(
                this.moreQueryPanelId,
                $("#" + this.parentId).closest(".dhx_cell_layout")
            );
        }
        //如果是通过goCard 激活的表格
        if (
            AssertUtils.isNotNull(
                $("#" + this.parentId)
                    .closest(".ivu-card")
                    .get(0)
            )
        ) {
            this.goCard = true;
            _initQueryPanelByDxCell(
                this.moreQueryPanelId,
                $("#" + this.parentId).closest(".ivu-card")
            );
        }
    }

    //获取查询区域panel的高定
    getQueryPanelHeight() {
        let moreCtl = this;
        if (this.dxLayout === true) {
            return (
                parseFloat(
                    $("#" + moreCtl.parentId)
                        .closest(".dhx_cell_layout")
                        .css("height")
                ) - 35
            );
        } else {
            return (
                parseFloat(
                    $("#" + moreCtl.parentId)
                        .closest(".ivu-card")
                        .css("height")
                ) - 35
            );
        }
    }

    //获取查询区域panel的离左边的间距
    getQueryPanelLeftPos() {
        let moreCtl = this;
        if (this.dxLayout === true) {
            return (
                parseFloat(
                    $("#" + moreCtl.parentId)
                        .closest(".dhx_cell_layout")
                        .css("width")
                ) - 400
            );
        } else {
            return (
                parseFloat(
                    $("#" + moreCtl.parentId)
                        .closest(".ivu-card")
                        .css("width")
                ) - 400
            );
        }
    }

    //初始化查询区域
    initQueryBody(moreQueryPanelId) {
        this.initBody = true;
        let moreCtl = this;

        let queryAry = [];
        //对查询项 进行初始化过滤相关处理
        this.queryAry = EditorTypeUtils.getQueryAry(this.fieldAry);
        queryAry = this.queryAry;
        let goingForm = new GoingForm("query", moreCtl.prefixCls);
        //初始化form对象
        goingForm.initForm({
            fieldAry: queryAry,
            colNum: moreCtl.colNum,
            labelWidth: moreCtl.labelWidth,
            inputWidth: moreCtl.inputWidth
        });
        this.goingFrom = goingForm;
        if (AssertUtils.isNotEmpty(moreCtl.id)) {
            this.vueObj.$store[moreCtl.id] = goingForm;
        }
        //设置内容
        $(`#${moreQueryPanelId}_body`).html(goingForm.html());

        //初始化控件 根据类名称
        EditorTypeUtils.initGoCtlByClass(
            $(`#${moreQueryPanelId}_body`),
            this.inputWidth,
            this
        );
    }

    //获取选项对应的html代码
    getItemHtml(item) {
        return EditorTypeUtils.getItemHtmlByType(item, "query", this);
    }

    //初始化事件
    initEvent() {
        let moreCtl = this;
        //设置高级按钮的点击事件
        $(`#${this.btnId}`).click(function () {
            //添加遮盖层
            $(`<div class='page-cover more-query-cover'  style="z-index: ${GoingUtils.getCurMaxZIndex()}" onclick="window._closeMoreQueryById(this,'${moreCtl.moreQueryPanelId}');"></div>`).appendTo($("#" + moreCtl.moreQueryPanelId).parent());

            //设置高度
            $("#" + moreCtl.moreQueryPanelId)
                .show()
                .css("height", moreCtl.getQueryPanelHeight())
                .css("zIndex", GoingUtils.getCurMaxZIndex())
                .css("left", moreCtl.getQueryPanelLeftPos());
            $("#" + moreCtl.moreQueryPanelId)
                .removeClass("fadeOutRight")
                .addClass("fadeInRight");
            //如果是第一次点击则构建form内容
            if (!moreCtl.initBody) {
                moreCtl.initQueryBody(moreCtl.moreQueryPanelId);
            }
        });

        //初始化事件
        _initMoreQueryEvent(this.moreQueryPanelId, moreCtl);
    }
}



// WEBPACK FOOTER //
// ./goingsrc/jsCom/comCtl/GoMoreQueryCtl.js